
<button
    [disabled]="isDisabled"
    
    [ngClass]="[
    isDisabled ? inactiveClass : activeClass,
    'run-button',
    'run-strategy-button',
    customClass
    ]"

    (click)="onClick()">
    <span *ngIf="!isLoading">{{ label }}</span>
    <fa-icon *ngIf="isLoading" [icon]="faSpinner" class="spinner-icon fa-spin-pulse"></fa-icon>
</button>

